import { render, staticRenderFns } from "./SkillLabourersTable.vue?vue&type=template&id=ad6b4988&scoped=true&"
import script from "./SkillLabourersTable.vue?vue&type=script&lang=js&"
export * from "./SkillLabourersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6b4988",
  null
  
)

export default component.exports